import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class ParceiroService {
  urlBase = `${environment.urlBase}/parceiro`;

  constructor(private  http: HttpClient) { }

  buscarParceiroDoAcesso(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(this.urlBase);
  }
}
